import { render, staticRenderFns } from "./UpdateContractValidity.vue?vue&type=template&id=1c1c8a4e&scoped=true"
import script from "./UpdateContractValidity.vue?vue&type=script&lang=js"
export * from "./UpdateContractValidity.vue?vue&type=script&lang=js"
import style0 from "./UpdateContractValidity.vue?vue&type=style&index=0&id=1c1c8a4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1c8a4e",
  null
  
)

export default component.exports